import type { PageProps } from 'gatsby';
import React, { useEffect } from 'react';

import NotFound from '@components/NotFound';

import { useCuration } from '@hooks/useCuration';
import { useFeatureFlags } from '@hooks/useFeatureFlags';

import { TrackerType } from '@models/vital-sign';

import FormDrilldown from '@views/Records/VitalSigns/FormDrilldown';

export default function AddVitalSignRecordPage({ params }: PageProps) {
  const { startAddingRecord, stopCurating } = useCuration();
  const { flags } = useFeatureFlags();

  useEffect(() => {
    startAddingRecord();
    return () => stopCurating();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {flags.isVitalSignUpdateObservationEnabled ? (
        <FormDrilldown {...params} type={TrackerType.VitalSigns} />
      ) : (
        <NotFound />
      )}
    </>
  );
}
